import React, { useEffect } from "react";
import Logo from "../assets/mainlogo.png";
import Fireworks from "../assets/fireworks.mp4";
import Instagram from "../assets/Instagram";
import Facebook from "../assets/Facebook";
import Tiktok from "../assets/Tiktok";

import TagManager from "react-gtm-module";

const gtmId = "GTM-T4QRDGLB";
const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};

const Thanks = () => {
  useEffect(() => {
    initializeTagManager();
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="navbar">
        <div className="nav-logo-div">
          <img alt="TheBooker Logo" src={Logo} />
          <p>TheBooker</p>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <video
            playsInline
            autoPlay
            muted
            loop
            style={{ objectFit: "contain", width: 400 }}
          >
            <source src={Fireworks} type="video/mp4"></source>
          </video>
          <h1
            style={{
              fontFamily: "Hurme-Bold",
              color: "#008a80",
              padding: "0 10px",
            }}
          >
            Thank you for your subscription!
          </h1>
          <p
            style={{
              fontFamily: "Hurme-Light",
              marginTop: 10,
              padding: "0 10px",
            }}
          >
            We will send you all the updates about TheBooker launch, newest
            features, and deals via email!
          </p>
          <div
            onClick={() => window.location.replace("/")}
            className="subscribe-btn"
            style={{ marginTop: 25 }}
          >
            BACK TO THE WEBSITE
          </div>
        </div>
      </div>

      <div className="footer-thanks-main">
        <div
          className="footer-thanks"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <a
              href="https://www.instagram.com/thebookerapp?igsh=OWEwYXg5YjQ0NXQx"
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: "15px" }}
            >
              <Instagram width={30} height={30} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61555465270361&mibextid=ZbWKwL"
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: "15px" }}
            >
              <Facebook width={30} height={30} />
            </a>
            <a
              href="https://www.tiktok.com/@thebooker.app?_t=8laJs404Hl2&_r=1"
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: "15px" }}
            >
              <Tiktok width={30} height={30} />
            </a>
          </div>
          <p>TheBooker App. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Thanks;
